export default "__VITE_ASSET__nL0chEzs__"